import React, { useEffect, useRef, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import {
  extractNumbers,
  getselectedIds,
  isEmptyObject,
  MakeAxiosRequest,
} from "../../../utils/handler";
import { phoneRegex } from "../../../Constants";
import { useDispatch } from "react-redux";
import FormFields from "../../../Components/inputs/FormFields";
import { SwalError, SwalSuccess } from "../../../Components/SwalFns";
import { updateProfile } from "../../../features/authSlice";
import NewRelationship from "./../NewRelationship";
import { InfoModal } from "../../../Components/modals/InfoModal";
import Loader from "../../../Components/loader/Loader";
import UpdateInfoLayout from "./UpdateInfoLayout";

function MedicalInformation(props) {
  const {
    showModal,
    closeModal,
    editKey,
    listingFn,
    profileEdit,
    getResponse,
    updateBillingInfo,
    showMoreInfo = false,
    isMaxineStar = false,
    handleBack
  } = props;
  const methods = useForm();
  const dispatch = useDispatch();
  const { handleSubmit, reset, setValue, watch, trigger, getValues, control } =
    methods;
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitDisabled, setSubmitDisabled] = useState(false);

  const [prefillDetails, setPrefillDetails] = useState([]);
  const [optionsList, setOptionsList] = useState({
    relations: [],
    proxyType: [],
    additionalNeed: [],
    states: [],
    responsiblePartyList: [],
    otherRelation: [],
  });

  // const [responsiblePartyOther, setResponsiblePartyOther] = useState({});

  // const submitUrl =  profileEdit ? '/updateprofile' : (editKey ? '/updateproxy' : '/saveproxy');
  const submitUrl = profileEdit
    ? "/updateaditionalcustomerdetails"
    : "/updateaditionalrelationdetails";

  const fetchData = async () => {
    try {
      const statesList = await MakeAxiosRequest("post", "/getstates");
      const createproxyinfo = await MakeAxiosRequest(
        "post",
        "/createproxyinfo"
      );
      if (!profileEdit && editKey) {
        const edit = await MakeAxiosRequest(
          "post",
          "/getaditionalrelationdetails",
          { user_proxy_key: editKey, type: "medical_information" }
        );
        setPrefillDetails({ ...edit.data.relationDetails,medical_types:edit.data.medical_types });
      } else if (profileEdit) {
        const profile = await MakeAxiosRequest("post", "/getaditionalcustomerdetails",{ type: "medical_information" });;
        setPrefillDetails({...profile.data.customerDetails,medical_types:profile.data.medical_types});
      }

      const medicalTypes = createproxyinfo.data.medical_types?.map((item) => ({
        id: item.id,
        name: item.medical_type,
        isSelected: item.is_selected_as,
        options: [
          {
            id: "y",
            name: "Yes",
          },
          {
            id: "n",
            name: "No",
          },
        ],
      }));

      setOptionsList({ medicalTypes });
      setIsLoading(false);
    } catch (error) {
      console.error("Error", error);
    }
  };

  useEffect(() => {
    fetchData();
    setSubmitDisabled(false);
    return () => {
      setSubmitDisabled(false);
      reset();
    };
  }, [showModal]);

  useEffect(() => {
    console.log(prefillDetails);
    
    setSubmitDisabled(false);
    reset({
      medical_information: [],
      show_medical_information_other:false,
    });

    const medicalInformation = [];
    prefillDetails.medical_types?.forEach((qns) => {
      if (qns.is_selected_as) {
        setValue(`medical_information-${qns.id}`, qns.is_selected_as);
        
        const entry = {
          medical_type_id: qns.id,
          is_selected_as: qns.is_selected_as
        };

        // Add 'other' field if medical_type_id is 6
        if (qns.id === 6) {
          entry.other = qns.other || '';
        }

        medicalInformation.push(entry);
      }
    });

    // Set the medical_information array
    setValue('medical_information', medicalInformation);

  }, [prefillDetails]);

  const submitData = async (data) => {
    console.log(data);
    // return;
    setSubmitDisabled(true);
    if (updateBillingInfo) {
      updateBillingInfo(data);
    } else {
      try {
        data.state = data.state_id;
        data.responsible_party_phone = extractNumbers(
          data.responsible_party_phone
        );
        const response = await MakeAxiosRequest("post", submitUrl, {
          ...data,
          user_proxy_key: editKey,
          type: "medical_information",
        });
        // console.log(response);
        if (response.status == 1) {
          // getResponse && getResponse(response.data,(profileEdit ? 'profile' : (editKey ? 'update' : 'create')))
          reset();
          handleBack ? handleBack() : closeModal();
          listingFn && listingFn();
          // if(response.data?.msg_key =='subText'){
          //   SwalSuccess({subText: response.data?.message, showbtn:true})
          // }else{
          SwalSuccess({ msg: response.message });
          // }
          // profileEdit && dispatch(updateProfile());
        } else if (response.status == 0) {
          SwalError({ msg: response.message });
        } else {
          // setError('phone_number', { type: 'custom', message: response.message });
          console.log(response.message);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    }
    setSubmitDisabled(false);
  };

  useEffect(() => {
    // console.log(watch('medical_information'));
    const existingVal = watch('medical_information').find(
      (item) => item.medical_type_id === 6
    );
    // console.log(existingVal);
    if(existingVal){
      setValue('show_medical_information_other',existingVal.is_selected_as==='y')
      setValue('medical_information_other',existingVal.other)
    }
  }, [watch('medical_information')])

  useEffect(() => {
    const existingIndex = watch('medical_information').findIndex(
      (item) => item.medical_type_id === 6
    );
    const preValue = watch('medical_information');
    if (existingIndex >= 0) {
      // console.log('if');
      preValue[existingIndex]['other'] = watch('medical_information_other');
    }
    // console.log(existingIndex);
    // console.log(preValue);
    setValue('medical_information', preValue);
  }, [watch('medical_information_other'),watch('show_medical_information_other')])
  
  const fields = [
    {
      name: "medical_information",
      className: "col-md-6 mb-3",
      parentClassName: "d-flex",
      type: "multipleRadio",
      questions: optionsList.medicalTypes,
      questionKey: "medical_type_id",
      answerKey: "is_selected_as",
      isShow: true,
    },
    {
      name: "medical_information_other",
      label: "Other",
      className: "col-12 mb-3",
      rules: {
        required: "Please provide details",
        maxLength: {
          value: 250,
          message: "Maximum 250 characters allowed"
        }
      },
      type: "textarea",
      isShow: watch('show_medical_information_other'),
    },
  ];

  if (isLoading) return <Loader />;
  return (
    <>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(submitData)}>
          <UpdateInfoLayout
                                title="Medical Information"
                                handleBack={handleBack}
                                isSubmitDisabled={isSubmitDisabled}
                              >
                                <FormFields fields={fields} />
                              </UpdateInfoLayout>

        </form>
      </FormProvider>
     
    </>
  );
}

export default MedicalInformation;
